import React, { Component } from 'react';
import { Col, Row } from "reactstrap";
import { FilaProcedimentoEnum } from '../../helpers/enums';
import { getLoggedInUser } from '../../helpers/authUtils';
import moment from 'moment';
import CrudBar from '../../gb-components/CrudBar';
import { getFilasExcel, getFilasRelatorioAguardando } from '../../Libs/filaProcedimentos';
import { age } from '../../helpers/utils';
import { toast } from 'react-toastify';
import PreLoaderWidget from '../../components/Loader';
import DropDownProcedimentos from '../../components/DropDownProcedimentos';
import LoadingFullScreen from '../../components/LoadingFullScreen';

export default class FilaRelatorioAbertos extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: getLoggedInUser(),
            loading: false,
            loadingExport: false,
            pacientes: null,
            secretaria: null,
            dataIni: moment().startOf('month').format("YYYY-MM-DD"),
            dataFin: moment().endOf('month').format("YYYY-MM-DD"),
            procedimento: null,
            ordenar: 'procedimento',
            ordenacoes: ["Procedimento", "Data inserção na fila"],
            selectedRadio: FilaProcedimentoEnum.Aguardando
        };
    }

    async componentDidMount() { }

    onChangeDataIni(ev) {
        this.setState({ dataIni: ev.target.value })
    }

    onChangeDataFin(ev) {
        this.setState({ dataFin: ev.target.value })
    }

    compare(a, b) {
        let comparison = 0;
        if (a > b) {
            comparison = 1;
        } else if (a < b) {
            comparison = -1;
        }
        return comparison;
    }

    async filtrar() {
        this.setState({ loading: true })
        try {
            const response = await getFilasRelatorioAguardando(
                this.state.user.secretaria,
                this.state.dataIni,
                this.state.dataFin,
                this.state.procedimento,
                this.state.selectedRadio
            )

            let dadosAux = response.data
            console.log(dadosAux)
            for (let index = 0; index < dadosAux.length; index++) {
                const element = dadosAux[index];
                if (element.paciente.nascimento) {
                    dadosAux[index].idade = age(element.paciente.nascimento)
                }
            }

            if (this.state.ordenar == "procedimento") {
                dadosAux.sort((a, b) => this.compare(a.procedimentoId, b.procedimentoId))
            }
            this.setState({ loading: false, pacientes: dadosAux })
        } catch (error) {
            this.setState({ loading: false })
            toast.error("Algo deu errado ao gerar o relatório")
        }
    }

    imprimirLista() {
        let div = document.querySelector("#printLista")
        if (div) {
            // div.classList.add("p-3");
            let wd = window.open("", "width=1200px,height=600", "wdPrint");
            wd.document.write(`<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css" integrity="sha384-1BmE4kWBq78iYhFldvKuhfTAU6auU8tT94WrHftjDbrCEXSU1oBoqyl2QvZ6jIW3" crossorigin="anonymous">`);
            let print = `
            <div style="max-width:1200px">
            <div class="text-center">
                <h2>Impressão Fila Procedimentos em Aberto</h2>
                <div>
                    ${this.state.dataIni ? `Data: ${moment(this.state.dataIni).format("DD/MM/YYYY")} até ${moment(this.state.dataFin).format("DD/MM/YYYY")}` : ''}
                    ${this.state.procedimento ? `<br/> Procedimento: ${this.state.procedimento}` : ''}
                </div>
            </div>
            <div class="p-1">${div.innerHTML}</div>
            </div>
            `;

            wd.document.write(print);

            setTimeout(() => {
                wd.print()
            }, 1000)
        }
    }

    async exportExcel() {
        if (!this.state.pacientes || this.state.pacientes.length == 0) {
            toast.info("Primeiro gere o relatório")
            return
        }
        this.setState({ loadingExport: true })
        try {
            await getFilasExcel(
                this.state.user.secretaria,
                this.state.dataIni,
                this.state.dataFin,
                this.state.procedimento,
                this.state.selectedRadio
            )
            this.setState({ loadingExport: false })
        } catch (error) {
            this.setState({ loadingExport: false })
            toast.error("Erro ao baixar o arquivo.")
        }

    }

    handleChangeRadio = event => {
        this.setState({
            selectedRadio: event.target.value
        });
    };

    render() {
        return (
            <div className="gb-cont-page">
                <CrudBar
                    title="Gestão de Fila - Relatório"
                    breadcrumb={["Globalbrain", "Gestão de Fila", "Relatório"]}
                    noSearch={true}
                    style={{ marginTop: "20px", marginBottom: "8px", maxWidth: "none" }}
                />

                {this.state.loadingExport && <LoadingFullScreen></LoadingFullScreen>}

                <div className="gb-page">
                    {this.state.loading ? (<div className="text-center"><PreLoaderWidget /></div>) :
                        <React.Fragment>
                            <Row>
                                <Col md={5} lg={4}>
                                    <label>Filtrar Periodo</label>
                                    <Row>
                                        <Col className="mr-1 pr-0">
                                            <input
                                                style={{ fontSize: '11px' }}
                                                type="date"
                                                className="form-control"
                                                value={this.state.dataIni}
                                                onChange={(ev) => this.onChangeDataIni(ev)} />
                                        </Col>
                                        <Col className="ml-0 pl-0">
                                            <input
                                                style={{ fontSize: '11px' }}
                                                type="date"
                                                className="form-control"
                                                value={this.state.dataFin}
                                                onChange={(ev) => this.onChangeDataFin(ev)} />
                                        </Col>
                                    </Row>
                                </Col>
                                <Col md={6} className='d-flex justify-content-center align-items-end'>
                                    <DropDownProcedimentos
                                        procedimentoSelecionado={this.state.procedimento}
                                        change={event => {
                                            if (event && event.value) {
                                                this.setState({
                                                    procedimento: event
                                                })
                                            }
                                        }}
                                    />
                                </Col>
                                <Col md={2} lg={1} className='d-flex justify-content-center align-items-end'>
                                    <button type="button" className="btn gb-button" style={{ minWidth: "100%" }} onClick={() => this.filtrar()}>
                                        Gerar
                                    </button>

                                </Col>
                                <Col md={2} lg={1} className='d-flex align-items-end mt-1'>
                                    <button className="gb-button icon-btn mr-1" onClick={() => this.imprimirLista()}>
                                        <i className="fa fa-print drop-proc-icon"></i>
                                    </button>
                                    <button className="gb-button icon-btn" onClick={() => this.exportExcel()}>
                                        <i className="fa fa-file-excel drop-proc-icon"></i>
                                    </button>
                                </Col>
                            </Row>
                            <Row>
                                <Col className='mt-2'>
                                    <div>
                                        <label className="cont">
                                            Aguardando
                                            <input
                                                checked={this.state.selectedRadio === FilaProcedimentoEnum.Aguardando}
                                                type="radio"
                                                value={FilaProcedimentoEnum.Aguardando}
                                                name="group1"
                                                onChange={this.handleChangeRadio}
                                            />
                                            <span className="checkmark"></span>
                                        </label>

                                        <label className="cont">
                                            Agendados
                                            <input
                                                checked={this.state.selectedRadio === FilaProcedimentoEnum.ProcedimentoAgendado}
                                                type="radio"
                                                value={FilaProcedimentoEnum.ProcedimentoAgendado}
                                                name="group1"
                                                onChange={this.handleChangeRadio}
                                            />
                                            <span className="checkmark"></span>
                                        </label>
                                    </div>

                                </Col>
                            </Row>
                            <br />

                            {this.state.pacientes && this.state.pacientes.length > 0 ?
                                <div className="table-responsive" id="printLista">
                                    <table className="table gb-table">
                                        <thead>
                                            <tr>
                                                <th scope="col">Nº</th>
                                                <th scope="col">Paciente</th>
                                                <th scope="col">Status</th>
                                                <th scope="col">Gênero</th>
                                                <th scope="col">Data</th>
                                                <th scope="col">Idade</th>
                                                <th scope="col">Procedimento</th>
                                                <th scope="col">Grupo</th>
                                                <th scope="col">Sub Grupo</th>
                                                <th scope="col">Forma Organização</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.pacientes.map(
                                                (item, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td className="text-center td-fila">{item.seqFila}</td>
                                                            <td className="text-center td-fila">{item.paciente.nome}</td>
                                                            <td className="text-center td-fila"
                                                                style={{
                                                                    color: item.status === FilaProcedimentoEnum.ProcedimentoAgendado ? 'green' :
                                                                        item.status === FilaProcedimentoEnum.Recusado ? 'red' : 'orange'
                                                                }}>{item.status}</td>
                                                            <td className="text-center td-fila">{item.paciente.sexo}</td>
                                                            <td className="text-center td-fila">{moment(item.dataFila).format("DD/MM/YYYY H:mm")}</td>
                                                            <td className="text-center td-fila">{item.idade}</td>
                                                            <td className="text-center td-fila">{item.procedimento.descricao}</td>
                                                            <td className="text-center td-fila">{item.procedimento.grupoJoin.descricao}</td>
                                                            <td className="text-center td-fila">{item.procedimento.subGrupoJoin.descricao}</td>
                                                            <td className="text-center td-fila">{item.procedimento.formaOrganizacaoJoin.descricao}</td>
                                                        </tr>
                                                    )
                                                }
                                            )}
                                        </tbody>
                                    </table>

                                </div>
                                : <Row><h5 style={{ margin: "auto" }}>Utilize os filtros para gerar o relatório</h5></Row>
                            }
                        </React.Fragment>
                    }
                </div>
            </div>
        )
    }
}